import { officeBearers, executiveMembers, advisors } from "./teamData";

export const LEADERSHIP_GROUPS = [
  { id: "office-bearers", label: "Office Bearers" },
  { id: "executive-committee", label: "Executive Committee" },
  { id: "advisors", label: "Advisors" },
];

export const DEFAULT_WEBSITE_LEADERSHIP = {
  title: "Our leadership",
  subtitle: "Office bearers, executive committee, and advisors",
  groups: [officeBearers, executiveMembers, advisors].map((members, index) => ({
    id: LEADERSHIP_GROUPS[index].id,
    members: members.map((member, memberIndex) => ({
      id: `${LEADERSHIP_GROUPS[index].id}-${memberIndex + 1}`,
      name: member.name,
      position: member.position,
      photo: member.photo || null,
      photoWebp: member.photoWebp || null,
      photoPosition: member.photoPosition || "center",
    })),
  })),
  updatedAt: null,
};
